import React from "react";
import StatusBadge from "@/components/StatusBadge";
import { formatCurrency, formatDate } from "@/lib/format";
import { ExternalLink } from "lucide-react";

export default function InvoiceTable({ invoices, compact = false, testId = "invoice-table" }) {
  if (!invoices?.length) {
    return (
      <div data-testid={`${testId}-empty`} className="text-center py-12 text-slate-500">
        No invoices yet.
      </div>
    );
  }
  return (
    <div data-testid={testId} className="overflow-x-auto">
      <table className="w-full text-left">
        <thead>
          <tr className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <th className="py-3 px-4 font-medium">Invoice #</th>
            <th className="py-3 px-4 font-medium">Date</th>
            {!compact && <th className="py-3 px-4 font-medium">Due Date</th>}
            <th className="py-3 px-4 font-medium">Status</th>
            <th className="py-3 px-4 font-medium text-right">Amount</th>
            <th className="py-3 px-4 font-medium text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv) => (
            <tr
              key={inv.id}
              data-testid={`invoice-row-${inv.id}`}
              className="border-b border-slate-100 hover:bg-slate-50/60 transition-colors"
            >
              <td className="py-4 px-4 text-sm font-medium text-slate-900">{inv.number || inv.id.slice(0, 12)}</td>
              <td className="py-4 px-4 text-sm text-slate-600">{formatDate(inv.created)}</td>
              {!compact && <td className="py-4 px-4 text-sm text-slate-600">{formatDate(inv.due_date)}</td>}
              <td className="py-4 px-4"><StatusBadge status={inv.status} /></td>
              <td className="py-4 px-4 text-sm font-semibold text-slate-900 text-right">
                {formatCurrency(inv.total, inv.currency)}
              </td>
              <td className="py-4 px-4 text-right">
                <div className="flex items-center justify-end gap-2">
                  {inv.status === "open" && inv.hosted_invoice_url && (
                    <a
                      data-testid={`pay-now-${inv.id}`}
                      href={inv.hosted_invoice_url}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-md transition-colors"
                    >
                      Pay Now
                    </a>
                  )}
                  {inv.invoice_pdf && (
                    <a
                      data-testid={`view-pdf-${inv.id}`}
                      href={inv.invoice_pdf}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 text-xs font-semibold transition-colors"
                    >
                      View PDF <ExternalLink className="w-3 h-3" />
                    </a>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
